import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import AccountManagerPage from "./pages/AccountManagerPage";
import AuthProvider from "./components/AuthProvider";
import { BootstrapProvider } from "./components/BootstrapProvider";
import "@fontsource/inter"; // Defaults to weight 400
import "./global.css";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <AuthProvider>
      <BootstrapProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/account-manager" element={<AccountManagerPage />} />
          </Routes>
        </BrowserRouter>
      </BootstrapProvider>
    </AuthProvider>
  );
}
